import { action } from 'app/actions';

export const GET_STUDENT_ANSWER_LIST = 'simulated/correction/GET_STUDENT_ANSWER_LIST';
export const getStudentAnswerList = (payload) => action(GET_STUDENT_ANSWER_LIST, { payload });

export const GET_EVALUATION_INFORMATION = 'simulated/correction/GET_EVALUATION_INFORMATION';
export const getEvaluationInformation = (payload) =>
  action(GET_EVALUATION_INFORMATION, { payload });

export const SET_LOADING = 'simulated/correction/SET_LOADING';
export const setLoading = (payload) => action(SET_LOADING, { payload });

export const UPLOAD_EVALUATION_ESSAY_CARD = 'simulated/correction/UPLOAD_EVALUATION_ESSAY_CARD';
export const uploadEvaluationEssayCard = (payload) =>
  action(UPLOAD_EVALUATION_ESSAY_CARD, { payload });
